import React, { useRef, useEffect } from "react";
import "./LandingPage.css";
import logo from "../../components/logo.png";
import { useNavigate } from "react-router-dom";
import videoFile from "../../components/shop.mp4";

function LandingPage() {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  useEffect(() => {
    const playMedia = async () => {
      if (videoRef.current && audioRef.current) {
        try {
          await videoRef.current.play();
          await audioRef.current.play();
        } catch (error) {
          console.log("Autoplay blocked by browser, user interaction needed.");
        }
      }
    };
    playMedia();
  }, []);
  return (
    <>
      <div className="landing_page">
        <div className="landing_page_logo">
          <img src={logo} alt="" />
        </div>
        <h1 style={{ textAlign: "center" }}>Carolina Sauce Methods</h1>
        <h2>
          The Entrepreneur Mentorship Program You Need to Build Your Empire from
          the Ground Up
        </h2>
        <p style={{ textAlign: "center", fontSize: "1.5rem" }}>
          Carolina Sauce Methods gives you everything you need to start a
          thriving credit repair business, master the art of money management,
          and build the life of your dreams.
        </p>
        <h2>Begin your journey to financial freedom at $50/Month</h2>
        <div className="landing_page_buttons">
          <button className="black" onClick={() => navigate("/signup")}>
            Signup
          </button>
          <button className="gray" onClick={() => navigate("/signin")}>
            Signin
          </button>
        </div>
      </div>
      <div className="founder">
        <div className="founder_img">
          <video
            ref={videoRef}
            src={videoFile}
            autoPlay
            loop
            muted
            playsInline
            className="video"
          />
        </div>
        <div className="founder_details">
          <h1>Hi, I’m Carolina Spill</h1>
          <p>
            As the CEO of Carolina Sauce Methods, my goal and passion are to
            educate all people about credit literacy and to ensure the playing
            field is even, so everyone can reach financial goals. That’s exactly
            why I built this mentorship program.
          </p>
          <p>
            The strategies, techniques, and tools you’ll learn in this program
            were developed from my own personal experience building Carolina
            Sauce Methods. I know this mentorship program works because I’ve
            personally used it and seen monumental results in my own businesses.
          </p>
          <p>
            Enroll today for our Monthly Mentorship Program and let's scale your
            credit repair business to six-figure financial freedom and wealth!
          </p>
        </div>
      </div>
      <div className="packages">
        <div className="package">
          <h1>$50/Month</h1>
          <h2>Carolina Premium Membership</h2>
          <p>
            Gain access to resources that will boost your credit score and begin
            your journey to financial freedom.
          </p>
          <p>Get started now with Carolina Sauce Methods.</p>
          <button className="black" onClick={() => navigate("/signup")}>
            Start Now
          </button>
        </div>
        <div className="package">
          <h1>$150/Month</h1>
          <h2>Carolina Sauce Extra Packages</h2>
          <p>
            Beyond basic resources, gain access to deeper resources to boost
            your credit score even further.
          </p>
          <div>
            <li>150$Flight pAss for a month</li>
            <li>CC's & log ins</li>
            <li>Apartment hookups</li>
            <li>Tradeline vendors</li>
            <li>Ways to make money</li>
            <li>Hotel & air bnb hook ups</li>
            <li>And much more</li>
          </div>
          <p>The added packages are exclusive to Premium Members</p>
          <button className="black" onClick={() => navigate("/signin")}>
            Join Now
          </button>
        </div>
      </div>
    </>
  );
}

export default LandingPage;
